<template>
  <div class="container-page">
    <div>
      <p class="title-inner">Настройки системы</p>
    </div>
    <template v-if="isAccessAllowed">
      <div v-if="items?.length && !isLoading">
        <div
          class="mb-16 d-flex flex-row justify-content-between setting_container"
          v-for="item in items"
          :key="item.id"
        >
          <span class="setting_title">{{ item.name }}</span>
          <ComponentInput class="setting_input" type="number" v-model="item.value" :disabled="!canEdit" />
        </div>
      </div>

      <div v-if="canEdit">
        <ButtonComponent class="mr-8" mod="gradient-bg" @click="saveSettings"> Сохранить </ButtonComponent>
      </div>
    </template>
  </div>
</template>

<script>
  import ComponentInput from '@/common/components/ComponentInput.vue';
  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import Constants from '@/common/constants';
  import security from '@/common/mixins/security';

  import API from '../api/settings';

  const PERMISSIONS = {
    view: Constants.Permissions.SettingsView,
    edit: Constants.Permissions.SettingsEdit,
  };

  export default {
    name: 'Settings',
    components: {
      ComponentInput,
      ButtonComponent,
    },
    mixins: [security],
    data() {
      return {
        items: [],
        isLoading: false,
        canEdit: false,
      };
    },
    async created() {
      const isAllowed = await this.checkPermissionAndRedirect(PERMISSIONS.view);
      if (!isAllowed) return;

      this.checkPermission(PERMISSIONS.edit).then((response) => {
        this.canEdit = response.data;
      });
      this.loadSettings();
    },
    methods: {
      loadSettings() {
        this.isLoading = true;
        API.search().then((response) => {
          this.items = response.data;
          this.isLoading = false;
        });
      },
      saveSettings() {
        if (this.items.some((x) => !x.value)) {
          Constants.alert.fire('Ошибка', 'Проверьте правильность заполнения полей', 'error');
          return;
        }

        API.saveSettings(this.items)
          .then(() => {
            Constants.alert.fire('Сохранение', Constants.commonSuccess, 'success');
          })
          .catch(() => {
            Constants.alert.fire('Сохранение', Constants.commonError, 'error');
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .setting_container::v-deep {
    align-items: center;
    .input-group-wrapper {
      min-width: 30%;
      max-width: 30%;
      margin: 4px 8px;
    }
    button {
      margin: 0 4px;
    }
    .setting_title {
      font-weight: 400;
      font-size: 16px;
      line-height: 18px;
      color: #343434;
    }
  }
</style>
